import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { NotificationDetailLightViewModel } from '../Models/NotificationDetail-light-view-model.model';
import { NotificationDetailViewModel } from '../Models/NotificationDetail-view-model.model';
import { NotificationDetailViewViewModel } from '../Models/NotificationDetail-view-view-model.model';
import { NotificationDetailLookupViewModel } from '../Models/NotificationDetail-lookup-view-model.model';
import { NotificationDetailSearchModel } from '../Models/NotificationDetail-search-model.model';
import { BaseHttpServiceService } from 'src/app/sharedFeatures/services/base-http-service.service';
import { GenericResultModel } from 'src/app/sharedFeatures/models/generic-result.model';
import { CurrentUserService } from 'src/app/sharedFeatures/services/current-user.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationDetailsService extends BaseHttpServiceService {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
    currentUserService: CurrentUserService
  ) {
    super(http, translateService, currentUserService);
  }

  // search(model: NotificationDetailSearchModel): Observable<GenericResultModel<NotificationDetailLightViewModel[]>> {
  //     let url: string = `${this.baseUrl}/NotificationDetails/search`;
  //     return this.postData<GenericResultModel<NotificationDetailLightViewModel[]>>(url, model);
  // }

  getLight(
    pageIndex?: number,
    pageSize?: number,
    sort: string = 'null'
  ): Observable<GenericResultModel<NotificationDetailLightViewModel[]>> {
    let url: string = `${this.baseUrl}/NotificationDetails/get-light-collection/${pageIndex}/${pageSize}/${sort}`;
    return this.getData<GenericResultModel<NotificationDetailLightViewModel[]>>(
      url
    );
  }

  getLookup(): Observable<
    GenericResultModel<NotificationDetailLookupViewModel[]>
  > {
    let url: string = `${this.baseUrl}/NotificationDetails/get-lookup-collection`;
    return this.getData<
      GenericResultModel<NotificationDetailLookupViewModel[]>
    >(url);
  }

  getLookupPaged(
    pageIndex?: number,
    pageSize?: number,
    sort: string = 'null'
  ): Observable<GenericResultModel<NotificationDetailLookupViewModel[]>> {
    let url: string = `${this.baseUrl}/NotificationDetails/get-lookup-collection/${pageIndex}/${pageSize}/${sort}`;
    return this.getData<
      GenericResultModel<NotificationDetailLookupViewModel[]>
    >(url);
  }

  getById(id: any): Observable<NotificationDetailViewModel> {
    let url: string = `${this.baseUrl}/NotificationDetails/get/${id}`;
    return this.getData<NotificationDetailViewModel>(url);
  }

  getViewById(id: any): Observable<NotificationDetailViewViewModel> {
    let url: string = `${this.baseUrl}/NotificationDetails/get-view/${id}`;
    return this.getData<NotificationDetailViewViewModel>(url);
  }

  add(
    model: NotificationDetailViewModel
  ): Observable<NotificationDetailViewModel> {
    let url: string = `${this.baseUrl}/NotificationDetails/add`;
    return this.postData<NotificationDetailViewModel>(url, model);
  }

  addCollection(model: NotificationDetailViewModel[]): Observable<number> {
    let url: string = `${this.baseUrl}/NotificationDetails/add-collection`;
    return this.postData<number>(url, model);
  }

  update(
    model: NotificationDetailViewModel
  ): Observable<NotificationDetailViewModel> {
    let url: string = `${this.baseUrl}/NotificationDetails/update`;
    return this.postData<NotificationDetailViewModel>(url, model);
  }

  delete(id: any): Observable<any> {
    let url: string = `${this.baseUrl}/NotificationDetails/delete/${id}`;
    return this.postData<any>(url, null);
  }

  getAllNotificationsByUserIdAsync(
    model: NotificationDetailSearchModel
  ): Observable<GenericResultModel<NotificationDetailLightViewModel[]>> {
    let url: string = `${this.baseUrl}/NotificationDetails/GetAllNotificationsByUserIdAsync/${model.pagination.pageIndex}/${model.pagination.pageSize}/${model.userId}/${model.sorting}`;
    return this.getData<GenericResultModel<NotificationDetailLightViewModel[]>>(
      url
    );
  }

  getCountUnSeenNotificationsByUser(userId: any): Observable<any> {
    let url: string = `${this.baseUrl}/NotificationDetails/GetCountUnSeenNotificationsByUser/${userId}`;
    return this.getData<any>(url);
  }
  getCountUnSeenNotifications(userId: any): Observable<any> {
    // Use ChecklistFlow API endpoint (same as original MVC version)
    let url: string = `${this.mysteryShopperUrl}/Notification/GetNotificationCount`;

    const payload = {
      status: 1, // 1 = New/Unseen notifications
      userId: userId?.toString(),
    };

    // ChecklistFlow returns GlobalResponse<int> with format: { resultCode: 9, data: 5, message: "" }
    return this.postData<any>(url, payload).pipe(
      map((response: any) => {
        return response.data || 0;
      })
    );
  }

  seenNotificationByUserAsync(
    userId: any,
    notificationId: number
  ): Observable<any> {
    // Use ChecklistFlow API endpoint (same as original MVC version)
    let url: string = `${this.mysteryShopperUrl}/Notification/MarkNotificationSeen`;

    // ChecklistFlow endpoint expects just the id as parameter
    return this.postData<any>(url, notificationId);
  }

  seenNotificationListByUserAsync(
    userId: any,
    notificationIds: number[]
  ): Observable<any> {
    let url: string = `${this.baseUrl}/NotificationDetails/SeenNotificationListByUserAsync/${userId}}`;
    return this.postData<any>(url, notificationIds);
  }
  UpdateSeen(): Observable<any> {
    // This method marks all notifications as seen
    // Note: ChecklistFlow API doesn't have a "mark all as seen" endpoint
    // We'll keep using the PT API endpoint for this functionality
    let url: string = `${this.baseUrl}/PTNotificationDetail/UpdateSeen`;
    return this.postData<any>(url, {});
  }
}
